import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Users from "./views/Users.vue";
import Companies from "./views/Companies";
import Contracts from "./views/Contracts";
import Documents from "./views/Documents";
import Tasks from "./views/Tasks";
import Payments from "./views/Payments";
import ForgotPassword from "./views/ForgotPassword";

//edit by xunuo
import UserForm from "./components/UserForm";
import CompanyForm from "./components/CompanyForm";
import ContractForm from "./components/ContractForm";
import DocumentForm from "./components/DocumentForm";
import TaskForm from "./components/TaskForm";
import PaymentForm from "./components/PaymentForm";
import MeForm from "./components/MeForm";

import BalanceSheets from './views/BalanceSheets';
import BankStatements from './views/BankStatements';
import Cashflows from './views/Cashflows';
import Profits from './views/Profits';
import Receipts from './views/Receipts';
import ReceiptCounts from './views/ReceiptCounts';
import TaxFilings from './views/TaxFilings';

import TaxFilingForm from './components/TaxFilingForm';
import BankStatementForm from './components/BankStatementForm';
import ReceiptForm from './components/ReceiptForm';
import ProfitForm from './components/ProfitForm';
import BalanceSheetForm from './components/BalanceSheetForm';
import jwt_decode from "jwt-decode";
import CashflowsForm from "./components/CashflowsForm";
import CompanyInfoForm from "./components/CompanyInfoForm";

//公司列表-再跳转到合同页
import CompContract from "./views/CompContract";
import Firms from "./views/Firms";
import FirmForm from "./components/FirmForm";

//客户审核列表
import CompanyReviews from "./views/CompanyReviews";
import CompanyReviewForm from "./components/CompanyReviewForm";

//科目余额表
import Balances from './views/Balances';
import BalanceForm from './components/BalanceForm';

Vue.use(Router);

const beforeEnterFirmsOrUsers = (to, from, next) => {
  //firm 和 user无权限访问
  if (currentUser().role === 'user' || currentUser().role==='firm') {
    next('/');
  } else {
    next();
  }
};
const beforeEnterUsers = (to, from, next) => {
  //user无权限访问
  if (currentUser().role === 'user') {
    next('/company-info');
  } else {
    next();
  }
};
const onlyUsers = (to, from, next) => {
  //只有user可以访问
  if (currentUser().role === 'user') {
    next();
  } else {
    next('/');
  }
};

const beforeEnterSupers = (to, from, next) => {
  //只有超级管理员才有的权限
  if (currentUser().role !== 'super') {
    next('/');
  } else {
    next();
  }
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {path: "/", name: "home", component: Home,beforeEnter: beforeEnterUsers},
    {path: "/login", name: "login", component: Login},
    {path: "/forgot-password", name: "forgot-password", component: ForgotPassword},
    {path: "/me", name: "me", component: MeForm},

    {path: "/users", name: "users", component: Users,beforeEnter: beforeEnterFirmsOrUsers},
    {path: "/users/add", name: "user-form-add", component: UserForm,beforeEnter: beforeEnterFirmsOrUsers},
    {path: "/users/:username/edit", name: "user-form-edit", component: UserForm,beforeEnter: beforeEnterFirmsOrUsers},
    {path: "/users/:username/detail", name: "user-form-detail", component: UserForm, beforeEnter: beforeEnterFirmsOrUsers},

    {path: "/companies", name: "companies", component: Companies,beforeEnter: beforeEnterUsers},
    {path: "/companies/add", name: "company-form-add", component: CompanyForm,beforeEnter: beforeEnterUsers},
    {path: "/companies/:companyId/detail", name: "company-form-detail", component: CompanyForm,beforeEnter: beforeEnterUsers},
    {path: "/companies/:companyId/edit", name: "company-form-edit", component: CompanyForm,beforeEnter: beforeEnterUsers},

    {path: "/company-reviews", name: "company-reviews", component: CompanyReviews,beforeEnter: beforeEnterUsers},
    {path: "/company-reviews/add", name: "company-reviews-form-add", component: CompanyReviewForm,beforeEnter: beforeEnterUsers},
    {path: "/company-reviews/:companyId/detail", name: "company-reviews-form-detail", component: CompanyReviewForm,beforeEnter: beforeEnterUsers},
    {path: "/company-reviews/:companyId/edit", name: "company-reviews-form-edit", component: CompanyReviewForm,beforeEnter: null},
    {path: "/company-info", name: "company-info", component: CompanyInfoForm,beforeEnter: onlyUsers},
    //TODO company info form

    {path: "/tasks", name: "tasks", component: Tasks},
    {path: "/tasks/add", name: "task-form-add", component: TaskForm},
    {path: "/tasks/:taskId/detail", name: "task-form-detail", component: TaskForm},
    {path: "/tasks/:taskId/edit", name: "task-form-edit", component: TaskForm},

    {path: "/payments", name: "payments", component: Payments,beforeEnter: beforeEnterUsers},
    {path: "/payments/add", name: "payment-form-add", component: PaymentForm,beforeEnter: beforeEnterUsers},
    {path: "/payments/:paymentId/detail", name: "payment-form-detail", component: PaymentForm,beforeEnter: beforeEnterUsers},
    {path: "/payments/:paymentId/edit", name: "payment-form-edit", component: PaymentForm,beforeEnter: beforeEnterUsers},

    {path: "/contracts/comp", name: "contracts-comp", component: CompContract,beforeEnter: null},
    {path: "/contracts/add", name: "contract-form-add", component: ContractForm,beforeEnter: null},
    {path: "/contracts/:companyId", name: "contracts", component: Contracts,beforeEnter: null},
    {path: "/contracts/:contractId/detail", name: "contract-form-detail", component: ContractForm,beforeEnter: null},
    {path: "/contracts/:contractId/edit", name: "contract-form-edit", component: ContractForm,beforeEnter: null},

    {path: "/documents", name: "documents", component: Documents,beforeEnter: beforeEnterUsers},
    {path: "/documents/add", name: "document-form-add", component: DocumentForm,beforeEnter: beforeEnterUsers},
    {path: "/documents/:documentId/detail", name: "document-form-detail", component: DocumentForm,beforeEnter: beforeEnterUsers},
    {path: "/documents/:documentId/edit", name: "document-form-edit", component: DocumentForm,beforeEnter: beforeEnterUsers},

    {path: "/balance-sheets", name: "balance-sheets", component: BalanceSheets},
    {path: "/balance-sheets/add", name: "balance-sheet-form-add", component: BalanceSheetForm,beforeEnter: beforeEnterUsers},
    {path: "/balance-sheets/:balanceSheetId/detail", name: "balance-sheet-form-detail", component: BalanceSheetForm},
    {path: "/balance-sheets/:balanceSheetId/edit", name: "balance-sheet-form-edit", component: BalanceSheetForm,beforeEnter: beforeEnterUsers},

    {path: "/bank-statements", name: "bank-statements", component: BankStatements,beforeEnter: beforeEnterUsers},
    {path: "/bank-statements/add", name: "bank-statement-form-add", component: BankStatementForm,beforeEnter: beforeEnterUsers},
    {path: "/bank-statements/:bankStatementId/detail", name: "bank-statement-form-detail", component: BankStatementForm,beforeEnter: beforeEnterUsers},
    {path: "/bank-statements/:bankStatementId/edit", name: "bank-statement-form-edit", component: BankStatementForm,beforeEnter: beforeEnterUsers},

    {path: "/cashflows", name: "cashflows", component: Cashflows},
    {path: "/cashflows/add", name: "cashflow-form-add", component: CashflowsForm,beforeEnter: beforeEnterUsers},
    {path: "/cashflows/:cashflowId/detail", name: "cashflow-form-detail", component: CashflowsForm},
    {path: "/cashflows/:cashflowId/edit", name: "cashflow-form-edit", component: CashflowsForm,beforeEnter: beforeEnterUsers},

    {path: "/profits", name: "profits", component: Profits},
    {path: "/profits/add", name: "profit-form-add", component: ProfitForm,beforeEnter: beforeEnterUsers},
    {path: "/profits/:profitId/detail", name: "profit-form-detail", component: ProfitForm},
    {path: "/profits/:profitId/edit", name: "profit-form-edit", component: ProfitForm,beforeEnter: beforeEnterUsers},

    {path: "/receipts", name: "receipts", component: Receipts,beforeEnter: beforeEnterUsers},
    {path: "/receipts/add", name: "receipt-form-add", component: ReceiptForm,beforeEnter: beforeEnterUsers},
    {path: "/receipts/:receiptId/detail", name: "receipt-form-detail", component: ReceiptForm,beforeEnter: beforeEnterUsers},
    {path: "/receipts/:receiptId/edit", name: "receipt-form-edit", component: ReceiptForm,beforeEnter: beforeEnterUsers},
    {path: "/receipt-counts", name: "receipt-counts", component: ReceiptCounts,beforeEnter: beforeEnterUsers},

    {path: "/tax-filings", name: "tax-filings", component: TaxFilings,beforeEnter: beforeEnterUsers},
    {path: "/tax-filings/add", name: "tax-filing-form-add", component: TaxFilingForm,beforeEnter: beforeEnterUsers},
    {path: "/tax-filings/:taxFilingId/detail", name: "tax-filing-form-detail", component: TaxFilingForm,beforeEnter: beforeEnterUsers},
    {path: "/tax-filings/:taxFilingId/edit", name: "tax-filing-form-edit", component: TaxFilingForm,beforeEnter: beforeEnterUsers},

    //事务所
    {path: "/firms", name: "firms", component: Firms,beforeEnter: beforeEnterSupers},
    {path: "/firms/add", name: "firm-form-add", component: FirmForm,beforeEnter: beforeEnterSupers},
    {path: "/firms/:firmId/detail", name: "firm-form-detail", component: FirmForm,beforeEnter: beforeEnterSupers},
    {path: "/firms/:firmId/edit", name: "firm-form-edit", component: FirmForm,beforeEnter: beforeEnterSupers},

    //科目余额表
    {path: "/balances", name: "balances", component: Balances,beforeEnter: beforeEnterUsers},
    {path: "/balances/add", name: "balance-form-add", component: BalanceForm,beforeEnter: beforeEnterUsers},
    {path: "/balances/:balanceId/detail", name: "balance-form-detail", component: BalanceForm,beforeEnter: beforeEnterUsers},
    {path: "/balances/:balanceId/edit", name: "balance-form-edit", component: BalanceForm,beforeEnter: beforeEnterUsers},

  ]
});

router.beforeEach((to, from, next) => {
  //console.log(to.name);
  let auth = localStorage.getItem('accessToken');
  if (!auth) {
    if (to.name !== 'login' && to.name !== 'forgot-password') {
      !!auth ? next() : next('/login');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;

function currentUser() {
  let accessToken = localStorage.getItem("accessToken");
  if (accessToken == null) {
    return null;
  } else {
    let decoded = jwt_decode(accessToken);
    return {username: decoded.sub, role: decoded.role};
  }
}
